import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";

export default function GuestPlayerPicker({ excludeIds = [], onAdd }) {
  const [list, setList] = useState([]);
  const [sel, setSel] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/players/club-directory").then((r) => setList(r.data)).catch(() => {});
  }, []);

  const options = list.filter((p) => !excludeIds.includes(p.id));

  const add = async () => {
    const p = options.find((x) => x.id === sel);
    if (!p) return;
    setBusy(true);
    try {
      await onAdd(p);
      setSel("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex gap-2 items-center flex-wrap" data-testid="guest-player-picker">
      <Select value={sel} onValueChange={setSel}>
        <SelectTrigger className="w-full sm:w-80" data-testid="guest-player-select">
          <SelectValue placeholder="Añadir jugador de otro equipo del club" />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {options.map((p) => (
            <SelectItem key={p.id} value={p.id}>
              {p.name} — {p.team_name || "Sin equipo"}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        type="button"
        size="sm"
        disabled={!sel || busy}
        onClick={add}
        className="bg-purple-600 hover:bg-purple-700 text-white font-bold"
        data-testid="guest-player-add"
      >
        <UserPlus className="h-4 w-4 mr-1.5" /> Añadir
      </Button>
    </div>
  );
}
